import { Injectable, Injector } from '@angular/core'
import { BaseOperation } from 'media.operations/ops/base'

// eslint-disable-next-line @typescript-eslint/no-type-alias
type OperationClass = new (..._: any[]) => BaseOperation

@Injectable({ providedIn: 'root' })
export class MediaOperationsService {
  ops: BaseOperation[] = []
  static registeredClasses: OperationClass[] = []

  constructor (
    private injector: Injector,
  ) {
    for (const c of MediaOperationsService.registeredClasses) {
      const op: BaseOperation = injector.get(c)
      op.id = c.name
      this.ops.push(op)
    }
    this.ops.sort((a, b) => a.weight - b.weight)
  }

  static register (cls: OperationClass): void {
    MediaOperationsService.registeredClasses.push(cls)
  }
}
